import React from "react";
import { Link } from "react-router-dom";
import { footerClasses } from "../styles/componentClasses";

export default function Footer() {
  return (
    <footer className={footerClasses.wrapper}>
      <div className={footerClasses.content}>
        <div className={footerClasses.brandBlock}>
          <span className={footerClasses.eyebrow}>Summer Editorial Guide</span>
          <p className={footerClasses.brandTitle}>
            Summer Jobs In Greece
          </p>
          <p className={footerClasses.brandCopy}>
            Explore stories, guides, and seasonal life in the Aegean.
          </p>
          <p className={footerClasses.detailCopy}>
            Built to feel closer to a travel journal than a job board, with practical seasonal advice and a softer Mediterranean mood.
          </p>
          <a
            href="https://www.facebook.com/groups/409310806532194/"
            className={footerClasses.communityLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Join our Facebook group to check jobs and community updates
          </a>
        </div>
      </div>

      <div className={footerClasses.legal}>
        <p>
          Copyright {new Date().getFullYear()} Summer Jobs Greece. All rights reserved.
        </p>
        <p className="flex flex-wrap items-center justify-center gap-3 text-sm">
          <Link to="/privacy" className={footerClasses.photoCreditLink}>
            Privacy Policy
          </Link>
          <span aria-hidden="true">|</span>
          <Link to="/terms" className={footerClasses.photoCreditLink}>
            Terms of Use
          </Link>
        </p>
        <p>
          Background photo by{" "}
          <a
            href="https://unsplash.com/photos/a-boat-sitting-on-top-of-a-snow-covered-slope-AEa4ozsujF4"
            className={footerClasses.photoCreditLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Julian Schaefer on Unsplash
          </a>
        </p>
      </div>
    </footer>
  );
}
